import React from 'react'
import { ResponsiveLine } from '@nivo/line'
import {  Box, Grid, Typography, Switch, FormControlLabel } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Bucket from '../../../components/Bucket'
import Revenu from '../Tabular/Revenu';
import Mechanic from '../Tabular/Mechanic';
import Job from '../Tabular/Job';
import PieArcLabel from '../Tabular/PieArcLabel';

const data =
[
    {
      "id": "Job Card",
      "color": "hsl(102, 70%, 50%)",
      "data": [
        {
          "x": "Jan",
          "y": 10
        },
        {
          "x": "Feb",
          "y": 12
        },
        {
          "x": "Mar",
          "y": 15
        },
        {
          "x": "Apr",
          "y": 20
        },
        {
          "x": "May",
          "y": 25
        },
        {
          "x": "Jun",
          "y": 30
        },
        {
          "x": "Jul",
          "y": 20
        },
        {
          "x": "Aug",
          "y": 25
        },
        {
          "x": "Sep",
          "y": 30
        },
        {
          "x": "Oct",
          "y": 35
        },
        {
          "x": "Nov",
          "y": 40
        },
        {
          "x": "Dec",
          "y": 45
        },
      ]
    },
    {
      "id": "Revenu",
      "color": "hsl(2, 70%, 50%)",
      "data": [
        {
          "x": "Jan",
          "y": 15
        },
        {
          "x": "Feb",
          "y": 25
        },
        {
          "x": "Mar",
          "y": 35
        },
        {
          "x": "Apr",
          "y": 45
        },
        {
          "x": "May",
          "y": 50
        },
        {
          "x": "Jun",
          "y": 55
        },
        {
          "x": "Jul",
          "y": 50
        },
        {
          "x": "Aug",
          "y": 35
        },
        {
          "x": "Sep",
          "y": 30
        },
        {
          "x": "Oct",
          "y": 25
        },
        {
          "x": "Nov",
          "y": 20
        },
        {
          "x": "Dec",
          "y": 15
        },
      ]
    },
  ]
function JobcardChart() {
  const navigate = useNavigate()
  const pageChange = (e) => { navigate('/Dashboard')};
  return (
    <Box mt={2}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
                {" "}
                Dash Board{" "}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Box>
                <Box display="flex" justifyContent="flex-end">
                  <span>Home</span>
                  <FormControlLabel
                    sx={{ marginLeft: "20px" }}
                    control={<Switch size="small" checked color="success" />}
                    onChange={pageChange}
                  />
                  <span>Tabular</span>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Bucket>
              <Box height="250px">
                <ResponsiveLine
                  data={data}
                  margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
                  xScale={{ type: "point" }}
                  yScale={{
                    type: "linear",
                    min: "auto",
                    max: "auto",
                    stacked: false,
                    reverse: false,
                  }}
                  yFormat=" >-.2f"
                  axisTop={null}
                  axisRight={null}
                  axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "Month",
                    legendOffset: 36,
                    legendPosition: "middle",
                  }}
                  axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "Amount",
                    legendOffset: -40,
                    legendPosition: "middle",
                  }}
                  pointSize={10}
                  pointColor={{ theme: "background" }}
                  pointBorderWidth={2}
                  pointBorderColor={{ from: "serieColor" }}
                  pointLabelYOffset={-12}
                  useMesh={true}
                  legends={[
                    {
                      anchor: "bottom-right",
                      direction: "column",
                      justify: false,
                      translateX: 100,
                      translateY: 0,
                      itemsSpacing: 0,
                      itemDirection: "left-to-right",
                      itemWidth: 80,
                      itemHeight: 20,
                      itemOpacity: 0.75,
                      symbolSize: 12,
                      symbolShape: "circle",
                      symbolBorderColor: "rgba(0, 0, 0, .5)",
                      effects: [
                        {
                          on: "hover",
                          style: {
                            itemBackground: "rgba(0, 0, 0, .03)",
                            itemOpacity: 1,
                          },
                        },
                      ],
                    },
                  ]}
                />
              </Box>
              </Bucket>
            </Grid>
            <Grid item xs={3} >
            <h3 style={{textAlign:'center'}}>Vehicle List</h3>
              <Bucket>
              <Grid item xs={12} >
                {/* <Typography  sx={{fontSize:'20px'}} fontWeight= 'bold' level="h1">Vechicle History</Typography> */}
                <PieArcLabel/>
                </Grid>
              </Bucket>
            </Grid>
            <Grid item xs={3}>
            <h3 style={{textAlign:'center'}}>Revenu List</h3>
              <Bucket>
              <Revenu/>
              </Bucket>
            </Grid>
            <Grid item xs={3}>
            <h3 style={{textAlign:'center'}}>Mechanic List</h3>
              <Bucket>
                <Mechanic/>
              </Bucket>
            </Grid>
            <Grid item xs={3}>
            <h3 style={{textAlign:'center'}}>Job List</h3>
              <Bucket>
                <Job/>
              </Bucket>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default JobcardChart;